<template>
  <v-icon
    color="purple"
    small class='mr-2'
    @click="showLastLogs"
    v-html="'mdi-clipboard-text-clock'"
    v-on="$listeners"
    v-bind="$attrs"
  />
</template>
<script>

export default {
  name: 'ShowLastLogsIcon',

  props: {
    processType: {
      required: true,
      type: String
    },
    integrationName: {
      required: true,
      type: String
    }
  },

  methods: {
    showLastLogs () {
      this.$versionable.decorators.monitoring.showLastLogs(this.integrationName, this.processType)
    }
  }
}
</script>
